import React, { useState } from 'react' //, useEffect 
import { Urls } from '../../Urls'
import { toast } from 'react-toastify';
import { Constants, Activity, ActivityString, currentRequestTimeStamp, getCurrentPath } from '../../Constants'
import axios from '../../Axios';
import Loader from '../Loader';
import classes from './Contactus.module.css';
const Contact = (props) => {
  // Activity([{"screen":"ContactUs","module":"ContactUs","user_activity":ActivityString.ContactUs,"timestamp":currentRequestTimeStamp()}])
  const [fname, setFname] = useState('')
  const [lname, setLname] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [query, setQuery] = useState('')
  // const [appContext, setappContext] = useState({})
  const [status, setStatus] = useState(false)
  // const [showInfoFlyout, setShowInfoFlyout] = useState(false);

  const message = 'submitting your query'
  const submitRequest = () => {
    Activity([{ "screen": getCurrentPath(), "module": props.module ? props.module : "Business Enquiry", "user_activity": ActivityString.SubmitQuery, "timestamp": currentRequestTimeStamp() }])
    if (fname === '') {
      toast.error('please fill first name');
      return false

    }
    var phoneno = /^\d{10}$/;
    if (!(phone.match(phoneno))) {
      toast.error('Please enter valid Mobile Number');
      return false

    }
    if (!(phone.match('^[0-9]+$'))) {
      toast.error('Please enter valid Mobile Number');
      return false
    }


    const emailValue = email && email.trim();
    if (!emailValue) {

      toast.error('Please enter valid email id');

      return;
    }

    if (!new RegExp(Constants.Email.regex).test(emailValue)) {
      toast.error('Please enter valid email id');
      // emailRef.focus();
      return;
    }





    if (query === '') {
      toast.error('Please Enter Query');
      return false

    }
    setStatus(true)
    axios.post(Urls.logURL, {
      from_email: 'connect@logisticsnow.in',
      user_type: 'company',
      subject: (props.display_for === 'General_Contact') ? (`Query from ${fname + '  ' + lname} for General Information`) : (`Query from ${fname + '  ' + lname} For Logistics Business Enquiry`),
      to_email: "connect@logisticsnow.in",
      content: (`Email :${email} Phone :${phone} Query:${query}`),
      activity: 'Email Request',
      email_status: 'Pending',
      Application_name: 'lorri',
      module_name: props.module ? props.module : "business enquiry",
      timestamp: currentRequestTimeStamp()
    })
      .then(res => {
        toast.success('Query  Submitted Successfully')
        // console.log(res)
        setStatus(false);
        setFname('');
        setEmail('');
        setLname('');
        setPhone('');
        setQuery('');
        (props.display_for === 'General_Contact') ? document.getElementById('contact_us_modal_button').click() : document.getElementById('contact_us_modal_transporter1').click();
      })
      .catch(Err => {
        console.log(Err)
        toast.error("Failed to submit Query");

        setStatus(false)
      }


      )
  }
  const sendEnquiryToLSP = (contacts) => {
    // console.log(contacts)
    setStatus(true)
    const contactsLengh = contacts.length
    let contactCounter = 0
    for (let i = 0; i < contactsLengh; i++) {
      if (contacts[i]['email'] !== '' && contacts[i]['email'] !== undefined) {
        axios.post(Urls.logURL, {
          from_email: 'connect@logisticsnow.in',
          user_type: 'company',
          subject: 'LoRRI: Truck requirement enquiry',
          to_email: contacts[i]['email'],
          content: (`
          <div><span>Dear <b>${sessionStorage.getItem('transporterName')}</b>,</span></div>
          <br/>

          <div><span><b>${fname + '  ' + lname}</b> has floated the following truck requirement on your LoRRI Profile:</span></div>
          <br/>

          <div><span><b>Email : ${email}<br/> Phone : ${phone}<br/> Query : ${query}</b></span></div>
          <br/>

          <div><span>Please respond on <b>“Company user’s email address”</b> for next steps</span></div>
          <br/>

          <div><span>
          Log in to https://transporter.lorri.in and enter your trucks availability in “Trucks Available Now!” section which will be visible to Fortune 500 and Major Indian companies.
          </span></div>
          <br/>

          <div><span>
          To view your complete profile, please visit https://transporter.lorri.in
          </span></div>
          <br/>

          <div><span>
          Should you need any assistance or have a question, please email (lorri@logisticsnow.in) or just call +91-8928008311 or +91-9867773519.
          </span></div>
          <br/>

          <div><span>
          Warm Regards,<br/> 
          Team LoRRI.
          <span></div>
          <br/>
          <div>
          The information contained in this electronic message and any attachments to this message are intended for
          the exclusive use of the addressee(s) and may contain proprietary, confidential or privileged information. 
          If you are not the intended recipient, you should not disseminate, distribute or copy this e-mail. 
          Please notify the sender immediately and destroy all copies of this message and any attachments contained in it.
          </div>          
          `),
          activity: 'Email Request',
          email_status: 'Pending',
          Application_name: 'lorri',
          module_name: props.module ? props.module : "Business Enquiry",
          timestamp: getCurrentPath()
        })
          .then(res => {
            contactCounter += 1
            if (contactCounter === contactsLengh) {
              setFname('');
              setEmail('');
              setLname('');
              setPhone('');
              setQuery('');
              toast.success('Enquiry mail has been sent to the transporters, Thank you!')
              if (props.display_for === 'General_Contact')
                document.getElementById('contact_us_modal_button').click()
              else
                document.getElementById('contact_us_modal_transporter1').click();
            }
          })
          .catch(err => {
            setStatus(false)
            console.log(err)
          })
      }
    }
    setStatus(false)
  }
  return ((props.display_for === 'General_Contact') ? (
    <div className={`${classes['s-container']} ${classes['container']}`}>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div className="row">

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="fname"> First Name:</label>
                <input type="text" className="form-control" value={fname} id="fname" placeholder="Enter your first name" name="fname" required onChange={e => setFname(e.target.value)} />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="lname"> Last Name:</label>
                <input type="text" className="form-control" value={lname} id="lname" placeholder="Enter your last name" name="lname" onChange={e => setLname(e.target.value)} />
              </div>
            </div>

          </div>

          <div className="row">

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="contact"> Contact Number:</label>
                <input type="text" className="form-control" value={phone} id="contactNo" placeholder="Enter your contact number" name="contactNo" onChange={e => setPhone(e.target.value)} />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="lname"> Email:</label>
                <input type="email" className="form-control" value={email} id="email" placeholder="Enter your Email" name="email" onChange={e => setEmail(e.target.value)} />
              </div>
            </div>

          </div>

          <div className="row">

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="comment">Your query:</label>
                <textarea className="form-control" name="message" value={query} rows="5" id="comment" placeholder="How can we help you?" onChange={e => setQuery(e.target.value)}></textarea>
              </div>
            </div>

          </div>

          <button id="submit_contactus" align="center" name="contact" type="button" className="btn btn-success" onClick={submitRequest}>Submit</button>
        </div>
        <div className="col-6">
          <iframe title="map" className="ln_map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d942.0715887844566!2d72.95346901997146!3d19.182691254938575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b9ce5f1974c1%3A0x2dd35f3b0a6cdb7f!2sLogisticsNow!5e0!3m2!1sen!2sus!4v1578714730043!5m2!1sen!2sus" frameBorder="0" style={{ border: '0', height: '100%' }} allowFullScreen></iframe>
        </div>
      </div>
      <div className={`row ${classes['s-mail']}`}>
        <div className="col">
          <span className={`${classes['s-mail']}`}>You can mail us at <b> <a href="mailto:connect@logisticsnow.in">connect@logisticsnow.in</a></b> or you can call us at <b><a href="tel:+91 9653620207 "> +91 9653620207  </a> or <a href="tel:+91 9867773508 "> +91 9867773508</a></b> </span>

        </div>
      </div>
      <Loader show={status} message={message} />
    </div>
  ) : (<div className={`${classes['s-container']} ${classes['container']}`}>
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div className="row">

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="fname"> First Name:</label>
              <input type="text" className="form-control" value={fname} id="fname" placeholder="Enter your first name" name="fname" required onChange={e => setFname(e.target.value)} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="lname"> Last Name:</label>
              <input type="text" className="form-control" value={lname} id="lname" placeholder="Enter your last name" name="lname" onChange={e => setLname(e.target.value)} />
            </div>
          </div>

        </div>

        <div className="row">

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="contact"> Contact Number:</label>
              <input type="text" className="form-control" value={phone} id="contactNo" placeholder="Enter your contact number" name="contactNo" onChange={e => setPhone(e.target.value)} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="lname"> Email:</label>
              <input type="email" className="form-control" value={email} id="email" placeholder="Enter your Email" name="email" onChange={e => setEmail(e.target.value)} />
            </div>
          </div>

        </div>

        <div className="row">

          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="comment">Specify your Logistics Requirement</label>



              <textarea className="form-control" name="message" value={query} rows="5" id="comment" placeholder="How can we help you?" onChange={e => setQuery(e.target.value)}></textarea>
              <span className={`${classes['s-note']}`}><b>Note :</b>
    Specify your location origins, destinations, truck type, warehousing etc.<br />
    Please provide timeline for procuring the mentioned requirements
</span>
            </div>
          </div>

        </div>

        <center>
          <button name="contact" type="button" className="Submit_query_button1" onClick={() => sendEnquiryToLSP(JSON.parse(sessionStorage.getItem('contactInfo')))} >Submit</button>
        </center>
      </div>

    </div>
    <div className={`row ${classes['s-mail']}`}>
      <div className="col">
        <span className={`${classes['s-mail']}`}>You can mail us at <b> <a href="mailto:connect@logisticsnow.in">connect@logisticsnow.in</a></b> or you can call us at <b><a href="tel:+91 9653620207 "> +91 9653620207  </a> or <a href="tel:+91 9867773508 "> +91 9867773508</a></b> </span>

      </div>
    </div>
    <Loader show={status} message={message} />
  </div>))
}
export default Contact;